import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { MODULES } from '../components/Sidebar';

// "Mais" é o mapa completo do sistema no toque, onde antes ficava o hambúrguer.
//
// Fica de fora só o que já é aba (Conversas e Contatos): repetir na lista faz a
// pessoa duvidar se são a mesma coisa.
const JA_E_ABA = ['/ti/atendimentos', '/ti/contatos'];

export default function Mais() {
  const { user, logout, temPermissao } = useAuth();
  const navigate = useNavigate();

  const liberado = (item) => {
    const principal = item.permissao && temPermissao(item.permissao);
    const alternativa = item.permissaoAlternativa && temPermissao(item.permissaoAlternativa);
    if (item.permissao && !principal && !alternativa) return false;
    return true;
  };

  const grupos = MODULES
    .map((mod) => ({
      ...mod,
      items: mod.items.filter((i) => !JA_E_ABA.includes(i.to) && liberado(i)),
    }))
    .filter((mod) => mod.items.length > 0);

  // Ajustes pessoais valem pra qualquer um que entra — não dependem de perfil.
  grupos.push({
    key: 'voce',
    label: 'Você',
    items: [{
      to: '/ti/configuracoes',
      label: 'Configurações',
      icon: 'bi-sliders',
      description: 'Assinatura das suas mensagens, respostas rápidas e avisos.',
    }],
  });

  return (
    <div className="content-shell mais-pagina">
      <h1 className="mais-titulo">Mais</h1>

      <div className="mais-ficha">
        <strong>{user?.nome || 'Operador'}</strong>
        <span>
          {user?.perfil_nome || 'Sem perfil'}
          {user?.filial ? ` · ${user.filial}` : ''}
        </span>
        <span>Entra como {user?.usuario || 'sem identificação'}</span>
      </div>

      {grupos.map((mod) => (
        <section key={mod.key} className="mais-grupo">
          <div className="mais-grupo__label">{mod.label}</div>
          <div className="mais-lista">
            {mod.items.map((item) => (
              <button
                key={item.to}
                type="button"
                className="mais-item"
                onClick={() => navigate(item.to)}
              >
                <i className={`bi ${item.icon} mais-item__icone`} />
                <span className="mais-item__texto">
                  <strong>{item.label}</strong>
                  <span>{item.description}</span>
                </span>
                <i className="bi bi-chevron-right mais-item__seta" />
              </button>
            ))}
          </div>
        </section>
      ))}

      <button
        type="button"
        className="mais-sair"
        onClick={() => { logout(); navigate('/login'); }}
      >
        Sair do Fio
      </button>
    </div>
  );
}
